import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import { FileDropper } from '@/core/FileDropper.atom';
import { getFormFieldProps, getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import type { FileDropperProps } from '@/core/FileDropper.atom';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';

export interface FileDropperIF extends FileDropperProps, ValidatingFormComponent<string | number> {
  component: 'FileDropperFormComponent';
}

export const FileDropperFormComponent = (props: FileDropperIF) => {
  const { name, extendValidation, validation, id } = props;

  const defaultValidation = (value: string | number | undefined) => {
    const stringValue = value === undefined ? '' : value.toString();
    return _.isEmpty(_.trim(stringValue));
  };

  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);
  const formState = useForm().getState();

  return (
    <Field<string | number> name={name} validate={appliedValidation}>
      {({ input, meta }) => {
        const properProps = getFormFieldProps(formState, input, meta, props);

        return <FileDropper {...properProps} isValid={!properProps.showError} />;
      }}
    </Field>
  );
};
